export default "__VITE_ASSET__H_LfFW8A__"